import { useEffect, useState } from "react";
import Layout from "../../../components/Layouts/Layouts/Layout";
import EPlatformHeader from "../../../components/basic/EPlatformHeader";
import { useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import axios from "axios";
import toast from "react-hot-toast";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";
import { getURLbyEndPointV2 } from "../../../store/api";
import { country_list, role } from "../../auth/Register/AllRegiPageLists";
import "../../../pages/auth/Register/Register.css";
import { titleOptions } from "../../../store/AllListData";

const IACSignup = () => {
  const location = useLocation();
  const [confirmPassword, setConfirmPassword] = useState("");
  const [formData, setFormData] = useState({
    selectMembership: "",
    companyName: "",
    inputNumber: "",
    websiteAdd: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    country: "",
    pinCode: "",
    businessCategory: "",
    title: "",
    firstName: "",
    lastName: "",
    role: "",
    email: "",
    password: "",
    phoneNo: "",
    telephoneNo: "",
    claimStatement: null,
    disputeId: "",
    partyId: "",
    requestFor: "",
    isExisting: true,
    isTrial: false,
  });

  const [captchaValue, setCaptchaValue] = useState("");
  const [isCaptchaCorrect, setIsCaptchaCorrect] = useState(false);
  const [registerFormSuccess, setRegisterFormSuccess] = useState(false);
  const [formSuccessful, setFormSuccessful] = useState(false);
  const captcha_length = 6;

  const Profession = [
    "Exporter",
    "Importer",
    "Shipping line",
    "Indenting agent",
    "Freight Forwarders",
    "Custom Broker",
    "Port Authorities",
    "Logistics",
    "Transporter",
    "Bank",
    "Insurance Companies",
    "Mentor",
    "Lawyer",
    "Accountant",
    "Arbitrator Center",
    "New Market consultant",
    "Financial Adviser",
    "ADR PROFESSIONAL",
    "Chartered Accountant",
    "Company Secretary",
    "Export Adviser",
    "Commercial Adviser",
    "Innovation Adviser",
    "Digital Service Specialist",
    "Marketing Specialist",
    "Other",
  ];

  // Autofill from URL params
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const autofillData = {};
    const fields = [
      "companyName",
      "email",
      "firstName",
      "lastName",
      "phoneNo",
      "selectMembership",
      "disputeId",
      "partyId",
      "requestFor",
    ];
    fields.forEach((field) => {
      if (params.get(field)) autofillData[field] = params.get(field);
    });
    setFormData((prev) => ({ ...prev, ...autofillData }));
  }, [location.search]);

  // CAPTCHA setup
  useEffect(() => {
    loadCaptchaEnginge(captcha_length);
  }, []);

  const handleCaptchaChange = (evt) => {
    setCaptchaValue(evt.target.value);
    setIsCaptchaCorrect(validateCaptcha(evt.target.value, false));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: files[0],
      }));
    }
  };

  const handleConfirmChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const resetForm = () => {
    setFormData({
      selectMembership: "",
      companyName: "",
      inputNumber: "",
      websiteAdd: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "",
      pinCode: "",
      businessCategory: "",
      title: "",
      firstName: "",
      lastName: "",
      role: "",
      email: "",
      password: "",
      phoneNo: "",
      telephoneNo: "",
      claimStatement: null,
      disputeId: "",
      partyId: "",
      isExisting: true,
      isTrial: false,
    });
    setCaptchaValue("");
    setIsCaptchaCorrect(false);
  };

  const handleRegiFormSubmit = async (e) => {
    e.preventDefault();
    setRegisterFormSuccess(true);
    try {
      if (!isCaptchaCorrect) {
        toast.error("CAPTCHA is invalid");
        return;
      }

      const validateField = (field, fieldName, regex) => {
        if (!field || (typeof field === "string" && field.trim() === "")) {
          alert(`Invalid Form, ${fieldName} cannot be empty`);
          return false;
        }
        if (regex && !regex.test(field)) {
          alert(`Invalid Form, ${fieldName} is not in correct format`);
          return false;
        }
        return true;
      };

      const validatePassword = (password) => {
        const regex =
          /^(?=.*[a-z])(?=.*\d)(?=.*[A-Z]?)(?=.*[!@#$%^&*()_+[\]{}|;:',.<>?~\\/-]).{8,15}$/;
        return regex.test(password);
      };

      if (!validateField(formData.email, "Email")) return;
      if (!validateField(formData.firstName, "First Name")) return;
      if (!validateField(formData.lastName, "Last Name")) return;
      if (!validateField(formData.role, "Role")) return;
      if (!validateField(formData.companyName, "Company Name")) return;
      if (!validateField(formData.inputNumber, "Company Registration Number"))
        return;
      if (!validateField(formData.title, "Title")) return;
      if (!validateField(formData.businessCategory, "Professional Category"))
        return;
      if (!validateField(formData.address1, "Address Line 1")) return;
      if (!validateField(formData.address2, "Address Line 2")) return;
      if (!validateField(formData.country, "Country")) return;
      if (!validateField(formData.state, "State")) return;
      if (!validateField(formData.city, "City")) return;
      if (!validateField(formData.pinCode, "Pincode")) return;
      if (!validateField(formData.phoneNo, "Phone No")) return;
      if (!validatePassword(formData.password)) {
        alert(
          "Password must be 8–15 chars, contain lowercase, number & special character."
        );
        return;
      }
      if (formData.password !== confirmPassword) {
        alert("Passwords do not match");
        return;
      }

      const formDataToSend = new FormData();
      Object.keys(formData).forEach((key) => {
        if (key === "claimStatement") {
          if (formData[key]) formDataToSend.append(key, formData[key]);
        } else {
          formDataToSend.append(key, formData[key]);
        }
      });

      const res = await axios.post(
        getURLbyEndPointV2("createIACUser"),
        formDataToSend,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res?.data?.status) {
        toast.success(res.data.message);
        setFormSuccessful(true);
        resetForm();
      } else {
        toast.error(res?.data?.message || "An error occurred");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(error?.response?.data?.message || "An error occurred");
    } finally {
      setRegisterFormSuccess(false);
    }
  };

  return (
    <Layout>
      <EPlatformHeader heading="E-Platform IAC - Sign-Up Form" />
      <div className="d-flex justify-content-center">
        <form
          className="main-width my-3 d-flex flex-column justify-content-start align-items-start"
          onSubmit={handleRegiFormSubmit}
        >
          <h1>Join As an Other Party</h1>
          <p>
            Fill all required details carefully. Fields marked with * are
            mandatory. This form is exclusively for Arbitration panel members.
          </p>

          {/* Membership Type */}
          <h3 className="my-4">MEMBERSHIP TYPE</h3>
          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-5">*SELECT MEMBERSHIP</label>
            <select
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="selectMembership"
              value={formData.selectMembership}
              onChange={handleInputChange}
              disabled
              required
            >
              <option value="">Select membership...</option>
              <option value="Arbitration">Arbitration</option>
              <option value="Digital User">Digital User</option>
              <option value="Corporate">Corporate</option>
            </select>
          </div>

          {/* Company Details */}
          <h3 className="my-4">COMPANY DETAILS</h3>
          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*COMPANY NAME</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="companyName"
              value={formData.companyName}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">
              *COMPANY REGISTRATION NUMBER
            </label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="inputNumber"
              value={formData.inputNumber}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">WEBSITE</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="websiteAdd"
              value={formData.websiteAdd}
              onChange={handleInputChange}
              placeholder="https://example.com"
            />
          </div>

          {/* Basic Info */}
          <h3 className="my-4">ABOUT YOU</h3>

          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*TITLE</label>
            <div className="d-flex flex-column">
              <select
                style={{ width: "35vw" }}
                className="form-select rounded-0 ms-5"
                onChange={handleInputChange}
                value={formData.title}
                name="title"
                required
              >
                <option value="">Select a title</option>
                {titleOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*FIRST NAME</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*LAST NAME</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*EMAIL</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*PASSWORD</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*CONFIRM PASSWORD</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="confirmPassword"
              type="password"
              value={confirmPassword}
              onChange={handleConfirmChange}
              required
            />
          </div>

          {/* Profession */}
          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*PROFESSIONAL CATEGORY</label>
            <select
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="businessCategory"
              value={formData.businessCategory}
              onChange={handleInputChange}
              required
            >
              <option value="">Select category...</option>
              {Profession.map((item, i) => (
                <option key={i} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          {/* Role */}
          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*ROLE</label>
            <select
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="role"
              value={formData.role}
              onChange={handleInputChange}
              required
            >
              <option value="">Select role...</option>
              {role.map((r, i) => (
                <option key={i} value={r}>
                  {r}
                </option>
              ))}
            </select>
          </div>

          {/* Address */}
          <h3 className="my-4">ADDRESS DETAILS</h3>
          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*ADDRESS LINE 1</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="address1"
              value={formData.address1}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*ADDRESS LINE 2</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="address2"
              value={formData.address2}
              onChange={handleInputChange}
              required
            />
          </div>

          {/* Country, City, State, Pincode */}
          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*COUNTRY</label>
            <select
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="country"
              value={formData.country}
              onChange={handleInputChange}
              required
            >
              <option value="">Select country...</option>
              {country_list.map((c, i) => (
                <option key={i} value={c}>
                  {c}
                </option>
              ))}
            </select>
          </div>

          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*STATE</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="state"
              value={formData.state}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*CITY</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*PINCODE</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="pinCode"
              value={formData.pinCode}
              onChange={handleInputChange}
              required
            />
          </div>

          {/* Contact */}
          <h3 className="my-4">CONTACT DETAILS</h3>
          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">*PHONE NO.</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="phoneNo"
              value={formData.phoneNo}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">TELEPHONE</label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="telephoneNo"
              value={formData.telephoneNo}
              onChange={handleInputChange}
            />
          </div>

          {/* Claim Statement */}
          <h3 className="my-4">CLAIM STATEMENT</h3>
          <div className="w-100 mb-3 d-flex justify-content-between align-items-start">
            <label className="fw-semibold fs-6">
              YOUR CLAIM STATEMENT (PDF)
            </label>
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0"
              name="claimStatement"
              type="file"
              accept=".pdf"
              onChange={handleFileChange}
            />
          </div>

          {/* CAPTCHA */}
          <h3 className="my-4">SECURITY CHECK</h3>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <LoadCanvasTemplate />
            <input
              style={{ width: "35vw" }}
              className="form-control rounded-0 ms-3"
              placeholder="Type the given captcha word"
              name="captcha"
              value={captchaValue}
              onChange={handleCaptchaChange}
              maxLength={captcha_length}
              required
            />
          </div>
          <p className={isCaptchaCorrect ? "text-success" : "text-danger"}>
            {isCaptchaCorrect ? "CAPTCHA is valid" : "CAPTCHA is invalid"}
          </p>

          <div className="d-flex justify-content-center gap-4 my-4">
            <Button
              variant="secondary"
              className="px-5 py-2 rounded-1 border-0 fw-medium"
              onClick={resetForm}
            >
              RESET
            </Button>
            <Button
              type="submit"
              className="setup-bg-color  px-5 py-2 rounded-1 border-0 fw-medium"
              disabled={registerFormSuccess}
            >
              {!registerFormSuccess ? "REGISTER" : "PROCESSING..."}
            </Button>
          </div>
        </form>
      </div>
    </Layout>
  );
};

export default IACSignup;
